<template>
    <div class="form-elements">
        <div class="row" v-if="!downloadAuditoriaCsv.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" v-model="dataIni">
                </div>
                <div class="col-md-6">
                    <input type="date" v-model="dataFim">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getAuditoriaBoletos()" class="btn btn-primary btn-micro">Gerar Relatório</button>
                </div>
            </div>
        </div>
        <div v-else>
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                </div>
            </div>
        </div>
    </div>
    <!-- <Card title="Faturas" description="Relação de todos os Alunos e relação de faturas" icon="ion ion-ios-document">
        <button @click="getAuditoriaBoletos()" v-if='!downloadAuditoriaCsv.load' class="btn btn-block btn-lg btn-secondary">GERAR</button>
        <div v-else class="d-flex justify-content-center">
            <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
            </div>
        </div>
    </Card> -->
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApiV2 from '../../../../router/urlApiV2'
import Card from '../../../cards/card.vue';

export default {
    name: 'auditoriaBoletos',
    components: {
        ...spinners,
        Card,
    },
    data() {
        return {
            dataIni: '',
            dataFim: '',
            downloadAuditoriaCsv: {
                load: false
            },
        }
    },
    methods: {
        async getAuditoriaBoletos() {
            if (!this.dataIni || !this.dataFim) {
                this.$toasted.show('Preencha todos os campos', { position: 'top-right' })
                return
            }

            const dataInicio = new Date(this.dataIni)
            const dataFim = new Date(this.dataFim)

            if (dataInicio > dataFim) {
                this.$toasted.show('A data inicial não pode ser maior que a data final.', { position: 'top-right' })
                return
            }

            if (dataFim < dataInicio) {
                this.$toasted.show('A data final não pode ser menor que a data inicial.', { position: 'top-right' })
                return
            }

            const diferencaMeses = (dataFim.getFullYear() - dataInicio.getFullYear()) * 12 + (dataFim.getMonth() - dataInicio.getMonth())

            if (diferencaMeses > 3) {
                this.$toasted.show('O período não pode exceder 3 meses.', { position: 'top-right' })
                return
            }

            const params = {
                dataIni: this.dataIni,
                dataFim: this.dataFim,
            }

            this.downloadAuditoriaCsv.load = true

            await this.$http.get(`${urlApiV2}/faturamento/exportar/boletos-alunos-csv`, {
                params,
            })
                .then(this.downloadBoletos)
                .catch(err => {
                    this.$toasted.show(err.body.mensagem, { position: 'top-right' })
                })
                .finally(() => {
                    this.downloadAuditoriaCsv.load = false
                })

            // await this.$http.get(urlApi + '/boletos/relatorio-boletos-todos-alunos').then(this.downloadBoletos)
        },
        downloadBoletos(response) {
            if (response.body.dados) {
                let code64 = response.data.dados;
                var csv = 'data:text/csv;charset=utf-8,' + code64;

                var dlnk = document.getElementById('downloadCSV');
                dlnk.download = "auditoria_faturamento.csv";
                dlnk.href = csv;
                dlnk.click();
            } else {
                this.$toasted.show('Consulta não possui resultado', { position: 'top-right' })
            }
        },
        downloadCSV(response) {
            if (response.data.dados) {
                let code64 = response.data.dados;
                var csv = 'data:text/csv;charset=utf-8,' + code64;

                var dlnk = document.getElementById('downloadCSV');
                dlnk.download = "auditoria_alunos.csv";
                dlnk.href = csv;
                dlnk.click();
                this.downloadAuditoriaCsv.load = false
            } else {
                this.$toasted.show('Consulta não possui resultado', { position: 'top-right' })
                this.downloadAuditoriaCsv.load = false
            }
        },
    }
}
</script>
